export default __webpack_public_path__ + "static/media/27.9b61d4cf.webp";